import { InfoCircleTwoTone } from '@ant-design/icons';
import { Card, Popover, Tag, version } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { logger } from '@client/utils/logger.util';
import { getEnv, isDev } from '@common/utils';

import { SystemInfoItem } from './InfoItem';
import styles from './system.module.less';

export const SystemInfo = () => {
  const { t } = useTranslation();

  const env = import.meta.env;

  return (
    <Popover
      title={
        <div className={styles.infoTitle}>
          <span>{t('build.info')}</span>
          <Tag>{env.VITE_BUILD_VERSION}</Tag>
        </div>
      }
      content={
        isDev(env, logger) ? (
          <div className={styles.info}>
            <Card size="small" title={t('build.framework')}>
              <SystemInfoItem
                title={t('build.mode')}
                value={getEnv('MODE', { env, logger })}
              />
              <SystemInfoItem
                title={'Node.js'}
                value={getEnv('VITE_NODE_VERSION', { env, logger })}
              />
              <SystemInfoItem title={'React'} value={React.version} />
              <SystemInfoItem title={'AntDesign'} value={version} />
            </Card>
            <Card size="small" title={t('build.os')}>
              <SystemInfoItem
                title={t('build.osPlatform')}
                value={getEnv('VITE_OS_PLATFORM', { env, logger })}
              />
              <SystemInfoItem
                title={t('build.osRelease')}
                value={getEnv('VITE_OS_RELEASE', { env, logger })}
              />
            </Card>
          </div>
        ) : null
      }
      trigger={'click'}
    >
      <InfoCircleTwoTone />
    </Popover>
  );
};
